import { render, staticRenderFns } from "./SelectStatusFoodClaim.vue?vue&type=template&id=5c2f6e24&"
import script from "./SelectStatusFoodClaim.vue?vue&type=script&lang=js&"
export * from "./SelectStatusFoodClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports